export default "__VITE_ASSET__DpcUlnH8__"